import React from 'react'
import { Link } from 'react-router-dom';
import Styles from "../../../Styles/TopBar.module.css"
import { IconButton ,  } from "@mui/material";
import Logo from "../../../Assets/Full Logo 2.svg"
import Profile from "../../../Assets/profile.svg"
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';




const TopBar = (props) => {


 


  return (
     <div    className={Styles.container}
     >
      {/* LOGO */}
      <div className={Styles.Logocontainer}
       >
        <div className={Styles.burger}>
        <MenuIcon onClick={props.toggleSidebar}  style={{ width:"30px",  height:"30px"}}/>
        </div>

       <img  className={ Styles.images}     src={Logo} alt="/" width="115px" height="43px" />
      </div>

       {/* PROFILE */}
      <div className={Styles.Profilecontainer}
       >
      <IconButton type="button" disableRipple>
      <div className={Styles.SubProfile}
      >
        <Link to={"/Profile2"}><img src={Profile} alt="/"  /></Link>
        <p>Babatunde Samuel</p>
      
       </div>
      </IconButton>
    <div className={Styles.icons}>
      <IconButton disableRipple>
      <SettingsOutlinedIcon  className={Styles.settingsicon} sx={{  color:"#F3723F",  }}/>
      </IconButton>
      <IconButton disableRipple>
     <NotificationsIcon className={Styles.notifyicon}  sx={{  color:"#F3723F" }} />
      </IconButton>
      </div>
      </div>
     </div>
  )
}

export default TopBar;
